var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-divider',{staticClass:"divider-carts",attrs:{"content-position":"left"}},[_vm._v("Воронка ")]),_c('v-chart',{staticClass:"chart-e",attrs:{"option":_vm.option,"step_chart_count":_vm.step_chart_count,"autoresize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }